export const WARNING = {
  DARK: '#CC8100',
  DEFAULT: '#FFA000',
  LIGHT: '#FEB874',
  LIGHTER: '#FFECB8',
} as const;
